/* Countdown for sections/promo-countdown.liquid. Each visitor gets their own
   timer of data-minutes length. The end time is kept in localStorage so a
   page load does not reset it; once it passes, the timer starts over at the
   full length. */
(function () {
  if (customElements.get('promo-countdown')) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  class PromoCountdown extends HTMLElement {
    connectedCallback() {
      this.length = (parseInt(this.dataset.minutes, 10) || 118) * 60000;
      this.hours = this.querySelector('[data-hours]');
      this.mins = this.querySelector('[data-minutes-left]');
      this.secs = this.querySelector('[data-seconds]');
      this.end = this.readEnd();
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    readEnd() {
      let end = 0;
      try {
        end = parseInt(localStorage.getItem(this.dataset.key), 10) || 0;
      } catch (e) {}
      if (end <= Date.now() || end > Date.now() + this.length) {
        end = Date.now() + this.length;
        this.saveEnd(end);
      }
      return end;
    }

    saveEnd(end) {
      try {
        localStorage.setItem(this.dataset.key, String(end));
      } catch (e) {}
    }

    tick() {
      let left = this.end - Date.now();
      if (left <= 0) {
        this.end = Date.now() + this.length;
        this.saveEnd(this.end);
        left = this.length;
      }
      const total = Math.floor(left / 1000);
      this.hours.textContent = pad(Math.floor(total / 3600));
      this.mins.textContent = pad(Math.floor((total % 3600) / 60));
      this.secs.textContent = pad(total % 60);
    }
  }

  customElements.define('promo-countdown', PromoCountdown);
})();
